export default __webpack_public_path__ + "static/media/car.e2d92167.svg";